<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>Verify Deposits
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form>
      <div class="container-fluid visit-charge-body">
        <div class="row justify-content-center m-2">
          <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
            <div>{{ generalErrorMessage }}</div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2"/>
          <div v-if="account.microDepositStatus === 'Processed'" class="col-8">
            To complete the verification process enter the amounts of the 2 small deposits you received.
          </div>
          <div v-else class="col-8">
            The deposits haven't completed processing yet, please try again later.
          </div>
        </div>
        <div class="row">
          <div class="col-2">
          </div>
          <div class="col-8">
            <b-form-group :label-cols="4" label="Deposit 1" label-align="right" :state="stateForField('amount1')" :invalid-feedback="errorForField('amount1')">
              <b-form-input v-model="amount1"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" label="Deposit 2" label-align="right" :state="stateForField('amount2')" :invalid-feedback="errorForField('amount2')">
              <b-form-input v-model="amount2">></b-form-input>
            </b-form-group>
          </div>
        </div>
      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button :disabled="account.microDepositStatus !== 'Processed'" type="button" class="btn btn-orange float-right" @click.prevent="save()">
        <font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner" pulse/>
        Save
      </button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>

</template>

<script>
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import api from '@/services/api'
  import _ from 'lodash'

  export default {
    name: 'MicroDepositVerificationModal',

    mixins: [ErrorsMixin],

    components: {},

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      account: {
        type: Object,
        required: true
      },

      accountPayee: {
        type: Object,
        required: false
      },

      accountEmployer: {
        type: Object,
        required: false
      }
    },

    data () {
      return {
        amount1: '0.0',
        amount2: '0.0',
        verificationModel: {
          fundingSourceId: 0,
          amount1: 0.0,
          amount2: 0.0
        },
        payee: {
          organizationPayeeId: 0,
          firstName: '',
          lastName: ''
        },
        employer: {
          organizationEmployerId: 0,
          name: ''
        },
        isSaving: false
      }
    },

    watch: {
      accountPayee (newValue) {
        this.clearAllErrors()
        this.payee = _.clone(newValue)
      },

      accountEmployer (newValue) {
        this.clearAllErrors()
        this.payee = {
          organizationPayeeId: 0,
          firstName: '',
          lastName: ''
        }
        this.employer = _.clone(newValue)
      },

      account (newValue) {
        this.verificationModel.fundingSourceId = newValue.externalId
      }
    },

    methods: {
      validate () {
        this.clearAllErrors()

        return !this.hasErrors()
      },

      save () {
        if (this.isSaving) {
          return
        }

        if (!this.validate()) {
          return
        }

        this.clearAllErrors()

        this.verificationModel.amount1 = parseFloat(this.amount1)
        this.verificationModel.amount2 = parseFloat(this.amount2)
        this.isSaving = true
        let url = '/Dashboard/Employer/Accounts/VerifyDeposits'
        if (this.payee.organizationPayeeId) {
          url = '/Dashboard/Payee/Accounts/VerifyDeposits'
        }

        api.post(url, this.verificationModel).then(response => {
          this.isSaving = false
          this.$emit('accountVerified', false)
        }).catch(error => {
          this.isSaving = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to request payee verification: ' + error.message, error)
          }
        })
      },

      closeModal () {
        this.$emit('update:visible', false)
      }
    }
  }
</script>

<style scoped>

</style>
